<template>
  <div>
    <p>
      Dark forces of chaos seek to destroy imagination and rule over LEGO Universe!
    </p>
    <poll-images id="3c9e3e10-84fc-4de9-929f-8e74dae71ec0"></poll-images>
    <poll id="3c9e3e10-84fc-4de9-929f-8e74dae71ec0"></poll>
  </div>
</template>
